import {
    all, select, put, take, takeEvery,
} from 'redux-saga/effects';
import { push as pushRoute } from 'connected-react-router';

import { extractQueryParameters, buildQueryParameters } from 'helpers/RoutesHelpers';
import { salesmanFormHasErrors } from '../constants/FieldsValidation';

import { getLocationSelector } from '../../commons/selectors/RouterSelector';

import {
    REQUEST_POST_SUPPORT_ERROR,
    REQUEST_POST_SUPPORT_SUCCESS,
    postSupport,
} from '../../commons/reduxModules/APISupport';

import { getItemSelector as getMeSelector } from '../../commons/reduxModules/APIMe';

import {
    generateNotification,
    rawAddNotification,
} from '../../services/Notifications';

import {
    POST_SALESMAN_THREAD,
    getCurrentNameSelector,
    getCurrentMessageSelector,
    getCurrentEmailSelector,
    getCurrentEventTypeSelector,
    getCurrentPhoneSelector,
    getCurrentOrgaSelector,
    isQuestionErrorsDisplayedSelector,
    showQuestionErrors,
    hideQuestionErrors,
    getOrgaIdSelector,
    isSendingSelector,
} from '../reduxModules/App';

import Routes from '../constants/Routes';
import { getScopeSelector } from '../../commons/reduxModules/Authentication';
import Scopes from '../../constants/Scopes';

export function* callAction() {
    const [
        orgaId,
        orga,
        user,
        currentName,
        currentEmail,
        message,
        phone,
        currentEventType,
        questionErrorsDisplayed,
        scope,
        sending,
    ] = yield all([
        select(getOrgaIdSelector),
        select(getCurrentOrgaSelector),
        select(getMeSelector),
        select(getCurrentNameSelector),
        select(getCurrentEmailSelector),
        select(getCurrentMessageSelector),
        select(getCurrentPhoneSelector),
        select(getCurrentEventTypeSelector),
        select(isQuestionErrorsDisplayedSelector),
        select(getScopeSelector),
        select(isSendingSelector),
    ]);
    const userName = user ? `${user.first_name || ''} ${user.last_name || ''}` : '';
    const userEmail = user ? user.email_address || '' : '';
    const orgaName = orga ? orga.name : '';
    const name = currentName || orgaName || userName || '';
    const email = currentEmail || userEmail || '';

    const notificationPayload = {
        bulkName: 'Echec de l\'envoi du message',
        state: 'error',
        message: 'Une erreur inconnue est survenue lors de l\'envoi de votre formulaire',
    };

    const hasErrors = salesmanFormHasErrors({
        name,
        message,
        currentEventType,
        email,
    });
    //  Trying to save with displayed errors
    if (hasErrors && questionErrorsDisplayed) return;
    //  Trying to save with hidden errors
    if (hasErrors) {
        yield put(showQuestionErrors());
        return;
    }

    if (sending) {
        return;
    }

    yield put(postSupport({
        subject: `Demande Commerciale - ${currentEventType}`,
        type: 'BUSINESS_ENQUIRY',
        orga_name: name,
        email_address: email,
        phone,
        message,
        orga_id: orgaId,
    }));

    const action = yield take([
        REQUEST_POST_SUPPORT_SUCCESS,
        REQUEST_POST_SUPPORT_ERROR,
    ]);

    const location = yield select(getLocationSelector);
    const newLocation = location;
    const searchParameters = extractQueryParameters(location.search);
    searchParameters['support-modal'] = Routes.CONTACT_SALESMAN_SUCCESS.link;
    newLocation.search = buildQueryParameters(searchParameters);

    if (action.type === REQUEST_POST_SUPPORT_SUCCESS) {
        if (Scopes.USER === scope) {
            yield put(pushRoute(Routes.CONTACT_SALESMAN_SUCCESS.link));
        } else {
            yield put(pushRoute(newLocation));
        }
        yield put(hideQuestionErrors());
    } else {
        yield put(showQuestionErrors());
        yield put(rawAddNotification(
            generateNotification(notificationPayload),
        ));
    }
}

export function* watch() {
    yield takeEvery(POST_SALESMAN_THREAD, callAction);
}
